import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './rootReducer';

export default function configureStore() {
  const store = createStore(
    rootReducer,
    compose(applyMiddleware(
      thunkMiddleware)),
  );

  return store;
}
